import axiosHttpClient from "./axiosHttpClient";

export function getAll() {
	return axiosHttpClient.get('/projects');
}


